import React from 'react';
import { get as _get } from 'lodash';
import { EngagementEvent } from '../../types';
import Icon from '../common/Icon';

interface SignalHistoryProps {
  events: EngagementEvent[];
}

const SignalHistory: React.FC<SignalHistoryProps> = ({ events }) => {
  if (!events || events.length === 0) {
    return (
      <div className="bg-white border border-brand-grey01 rounded-brand p-8 mb-8 shadow-sm">
        <h3 className="text-xl font-bold mb-8 flex items-center gap-2">
          <Icon name="timeline" className="text-brand-pink" />
          Signal History
        </h3>
        <p className="text-brand-grey08 text-sm italic">No engagement history available.</p>
      </div>
    );
  }

  return (
    <div className="bg-white border border-brand-grey01 rounded-brand p-8 mb-8 shadow-sm relative overflow-hidden">
      <h3 className="text-xl font-bold mb-8 flex items-center gap-2">
        <Icon name="timeline" className="text-brand-pink" />
        Signal History
      </h3>
      
      <div className="space-y-12 relative pl-8 border-l-2 border-brand-grey01">
        {(events || []).map((event, i) => {
          const type = _get(event, 'type', 'Unknown Event');
          const asset = _get(event, 'asset', '');
          const date = _get(event, 'date', '');
          const intent = _get(event, 'intent', 'Low');
          const isHighIntent = intent === 'High';

          return (
            <div key={i} className="relative group">
              <div
                className={`absolute -left-[41px] top-1 w-5 h-5 ${
                  isHighIntent ? 'bg-brand-pink' : 'bg-brand-grey02'
                } rounded-full border-4 border-white shadow-md transition-transform group-hover:scale-125`}
              />
              
              <div className="flex justify-between mb-1">
                <h4 className="font-extrabold text-lg group-hover:text-brand-pink transition-colors">
                  {type}
                </h4>
                {date && (
                  <span className="text-[10px] font-bold bg-brand-grey01 px-3 py-1 rounded-pill">
                    {date}
                  </span>
                )}
              </div>

              {asset && (
                <p className="text-sm italic text-brand-grey08 mb-3">
                  Asset: "{asset}"
                </p>
              )}

              <div className="flex gap-2">
                <span className="px-3 py-1 bg-brand-aqua/20 text-brand-black text-[10px] font-bold rounded-pill uppercase">
                  Signal Detected
                </span>
                {isHighIntent && (
                  <span className="px-3 py-1 bg-brand-pink/20 text-brand-black text-[10px] font-bold rounded-pill uppercase">
                    High Intent
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SignalHistory;
